export default __webpack_public_path__ + "static/Graphik-SemiboldItalic-Web-a8e0a42aebd27b09d893d14e0491ca4b.svg";